import { FleetTime } from '@src/main/modules/ibdp/domain/fleet-time.interface';
import { FleetTimeEntity } from '@src/main/modules/ibdp/infrastructure/fleet-time.entity';

export function toFleetTime(entity: FleetTimeEntity): FleetTime {
  return {
    fleet: entity.flota,
    subFleet: entity.subflota,
    aircraftReadyTime: entity.tiempo_avionlisto,
    signInTime: entity.tiempo_firma,
    briefingTime: entity.tiempo_briefing,
  };
}

export function fromFleetTime(model: FleetTime): FleetTimeEntity {
  return {
    flota: model.fleet,
    subflota: model.subFleet,
    tiempo_avionlisto: model.aircraftReadyTime,
    tiempo_firma: model.signInTime,
    tiempo_briefing: model.briefingTime,
  };
}
